<template>
  <div class="login">
    <img src="/static/img/MCI-Blanc-Filets.svg" class="login__logo-engie" />
    <form @submit.prevent="login" class="login__form">
      <img src="/static/img/logo.svg" class="login__logo" />
      <div class="login__field-container email">
        <img src="/static/img/pictos/login.svg" class="" />
        <input
          type="email"
          id="login_email"
          name="login[email]"
          required
          class="login__field"
          :placeholder="$t('object.user.email')"
          v-model="email"
        />
      </div>

      <div class="login__field-container pass">
        <img src="/static/img/pictos/cadenas.svg" class="" />
        <input
          type="password"
          id="login_password"
          name="login[password]"
          required
          class="login__field"
          :placeholder="$t('object.security.password')"
          v-model="password"
        />
      </div>
      <div class="login__btn-container">
        <input type="submit" value="connexion" class="login__btn" />
      </div>
      <p class="login__help">{{ $t("object.security.login_help") }}</p>
    </form>

    <p class="login__baseline">{{ $t("global.security.baseline") }}</p>
    <router-link :to="{ name: 'SecurityResetPasswordAsk' }">
      <a class="login__reset-password">{{ $t("action.password.reset_ask") }}</a>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
    };
  },
  created() {
    this.$store.dispatch("hideLoader");
  },
  methods: {
    login: function () {
      let email = this.email;
      let password = this.password;

      this.$store
        .dispatch("auth/login", { email, password })
        .then((response) => {
          this.$store.dispatch("auth/refreshAuthorizations");
          this.$toastr.success(this.$i18n.t("success.security.logged_in"));
          this.$toastr.success(this.$i18n.t("success.security.loading_content"));
          this.$router.push({ name: "Home" });
        })
        .catch((error) => {
          this.$toastr.error(this.$i18n.t("error.security.login_failed"));
          this.$router.push({ name: "Login" });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

/* Chrome, Firefox, Opera, Safari 10.1+ */
::placeholder {
  color: white;
  opacity: 1; /* Firefox */
}

/* Internet Explorer 10-11 */
:-ms-input-placeholder {
  color: white;
}

.login {
  background-color: $color1;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  position: fixed;
  z-index: 21;
  top: 0;
  left: 0;
  &__logo-engie {
    position: fixed;
    top: 50px;
    left: 125px;
    width: 150px;
  }
  &__help {
    color: #fff;
    font-size: 10px;
    margin: 50px auto 0;
    text-align: center;
    width: 200px;
  }
  &__form {
    width: 300px;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 100%;
      margin-bottom: 70px;
    }
  }
  &__field-container {
    position: relative;
    img {
      position: absolute;
      left: 0;
      width: 12px;
      top: 20px;
    }
    &.email {
      img {
        width: 15px;
        top: 22px;
      }
    }
  }
  &__field {
    width: 100%;
    background-color: transparent;
    color: white;
    border: none;
    border-bottom: 1px solid white;
    padding: 20px 40px;
    outline: none;
    margin-bottom: 10px;
    font-size: 12px;
    font-family: "ClanPro";
    border-radius: 0;
  }
  &__btn {
    background-color: white;
    color: $vert;
    display: block;
    height: 60px;
    line-height: 60px;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
    border: none;
    margin-top: 30px;
    font-family: "ClanFFBlack";
  }
  &__btn-container {
    position: relative;
    &:before {
      content: "";
      display: block;
      position: absolute;
      bottom: -19px;
      left: 50%;
      margin-left: -20px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 20px 0 20px;
      border-color: #ffffff transparent transparent transparent;
    }
  }
  &__baseline {
    font-size: 10px;
    text-align: center;
    position: fixed;
    bottom: 15px;
    margin-bottom: 0;
    width: 100%;
    color: white;
  }
  &__reset-password {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .login {
    &__logo-engie {
      width: 50px;
      top: auto;
      bottom: 40px;
      left: 50%;
      margin-left: -25px;
    }
    &__form {
      .login__logo {
        width: 80%;
        margin: 0 auto;
        display: block;
        margin-bottom: 30px;
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .login {
    &__form {
      width: calc(100% - 40px);
      margin: 0 20px;
      left: 0;
      transform: translate(0, -60%);
      .login__logo {
        width: 60%;
        margin: 0 auto;
        display: block;
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Security/login.vue